import { BankRemittanceModelType } from '@teinor/erp/types/company/accounting/bankRemittance'
import { LittleModalCreateEdit } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { valueOrDefaultValue } from '../../../../../../../../utils/globals/valueOrDefaultValue'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { displayDateByString } from '../../../../../../../../utils/globals/date'


type ModalEditRemittanceProps = ModalEditComponentProps & {}


const ModalEditRemittance: React.FC<ModalEditRemittanceProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { t } = useTwinTranslation()
    const dictStatus = {
        0: { name: t('pendentS', 'Pendiente'), value: 0},
        1: { name: t('finished', 'Finalizado'), value: 1},
        2: { name: t('cancelled', 'Cancelado'), value: 2}
    }

    const fields: FormRender<BankRemittanceModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    readOnly: true
                },
                {
                    name: 'status',
                    label: t('status', 'Estado'),
                    component: 'CustomSelectWithSearchBar',
                    items: dictStatus,
                },
                {
                    name: 'createdAt',
                    label: t('date', 'Fecha'),
                    component: 'InputCalendarStateFull',
                    value: displayDateByString(allRowData?.createdAt),
                    readOnly: true,
                },
                {
                    name: 'id',
                    component: 'InputHidden'
                },
            ],
        },
    ]

  
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, allRowData)
        return (
            <LittleModalCreateEdit fields={parsedFields} translations={{
                title: t('editRemittance', 'Editar remesa'),
                button: t('save', 'Guardar')
            }} haveButtonPermissions={true} url={'/api/app/accounting/collectionAndPayments/updateBankRemittance'} {...rest} />
        )
    }
    return null
}


export default ModalEditRemittance;